const config = {
  apiRootUrl: process.env.REACT_APP_API_ROOT_URL,
  apiXauthToken: process.env.REACT_APP_API_XAUTH_TOKEN
}

module.exports = config
